import {
  userCandEditTurnos,
  userCandReadTurnos,
  userIsAdmin,
  userIsRecepcion,
  userCandReadAllTurnos
} from './helpers'
import { SELECT_PUESTOS } from './constants'

export const OPCIONES_MENU = {
  'Caja Diaria': {
    get permission() {
      return userIsRecepcion()
    },
    visible: false,
    items: [
      {
        text: 'Dashboard',
        route: '/caja/dashboard',
        get permission() {
          return userIsRecepcion()
        }
      },
      {
        text: 'A - Facturas de clientes',
        route: '/caja/a',
        get permission() {
          return userIsRecepcion()
        },
        color: '#4989a3',
        type: 'A'
      },
      {
        text: 'B - Prepagos y depósitos a cuenta',
        route: '/caja/b',
        get permission() {
          return userIsRecepcion()
        },
        color: '#4989a3',
        type: 'B'
      },
      {
        text: 'C - Conciliación prepagos/ depósitos a cuenta y facturas a crédito',
        route: '/caja/c',
        get permission() {
          return userIsRecepcion()
        },
        color: '#9b5ca5',
        type: 'C'
      },
      {
        text: 'D - Cobros con tarjeta de crédito/débito',
        route: '/caja/d',
        get permission() {
          return userIsRecepcion()
        },
        color: '#9b5ca5',
        type: 'D'
      },
      {
        text: 'E - Cobros en efectivo',
        route: '/caja/e',
        get permission() {
          return userIsRecepcion()
        },
        color: '#9b5ca5',
        type: 'E'
      },
      {
        text: 'F - Cobros transferencia',
        route: '/caja/f',
        get permission() {
          return userIsRecepcion()
        },
        color: '#9b5ca5',
        type: 'F'
      },
      {
        text: 'G - Buzones',
        route: '/caja/g',
        get permission() {
          return userIsRecepcion()
        },
        color: '#C96A30',
        // color: '#256f28',
        type: 'G'
      },
      {
        text: 'H - Pagos recepción',
        route: '/caja/h',
        get permission() {
          return userIsRecepcion()
        },
        color: '#b74b43',
        type: 'H'
      },
      {
        text: 'Cierre de caja',
        route: '/caja/arqueo',
        get permission() {
          return userIsRecepcion()
        }
      },
      {
        text: 'Cajas',
        route: '/caja/caja',
        get permission() {
          return userIsAdmin()
        }
      }
    ]
  },
  'Gestión de turnos': {
    visible: false,
    get permission() {
      return userCandReadTurnos() || userCandReadAllTurnos()
    },
    items: [
      {
        text: 'Asignar turnos',
        route: '/turnos/asignar-turnos',
        get permission() {
          return userCandEditTurnos()
        },
        items: SELECT_PUESTOS.map((puesto) => ({
          text: puesto.text,
          route: `/turnos/asignar-turnos/${puesto.value}`,
          get permission() {
            return userCandEditTurnos()
          }
        }))
      },
      {
        text: 'Ver turnos',
        route: '/turnos/ver-turnos-todos',
        get permission() {
          return userCandReadAllTurnos()
        },
        items: SELECT_PUESTOS.map((puesto) => ({
          text: puesto.text,
          route: `/turnos/ver-turnos-todos/${puesto.value}`,
          get permission() {
            return userCandReadAllTurnos()
          }
        }))
      },
      {
        text: 'Ver turnos',
        route: '/turnos/ver-turnos',
        get permission() {
          return userCandReadTurnos()
        }
      }
      // {
      //   text: 'Empleados',
      //   route: '/turnos/gestionar-empleados',
      //   permission: userCandEditTurnos()
      // },
      // {
      //   text: 'Puestos de trabajo',
      //   route: '/turnos/puestos-trabajo',
      //   permission: userCandEditTurnos()
      // }
    ]
  },
  // Reportes: {
  //   visible: false,
  //   get permission() {
  //     return userIsAdmin()
  //   },
  //   items: [
  //     {
  //       text: 'Imprimir Reporte de Caja',
  //       action: 'imprimirReporteCaja',
  //       get permission() {
  //         return userIsRecepcion()
  //       }
  //     }
  //   ]
  // },
  Configuración: {
    visible: false,
    get permission() {
      return userIsAdmin()
    },
    items: [
      {
        text: 'Usuarios',
        route: '/usuarios',
        get permission() {
          return userIsAdmin()
        }
      },
      {
        text: 'Valores de configuración',
        route: '/config/iniciar-valores',
        get permission() {
          return userIsAdmin()
        }
      },
      {
        text: 'Tarjetas de crédito',
        route: '/maestro-tarjetas-credito',
        permission: userIsAdmin()
      }
    ]
  }
}
